var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 101,
    viewBox: "0 0 104 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.8537 75.75C96.5446 75.75 99.1254 74.6859 101.028 72.7918C102.931 70.8977 104 68.3287 104 65.65V10.1C104 7.42131 102.931 4.85234 101.028 2.95822C99.1254 1.0641 96.5446 0 93.8537 0H40.3824C42.158 3.0805 43.122 6.565 43.122 10.1H93.8537V65.65H48.1951V75.75M68.4878 25.25V35.35H38.0488V101H27.9024V70.7H17.7561V101H7.60976V60.6H0V35.35C0 32.6713 1.06899 30.1023 2.97179 28.2082C4.8746 26.3141 7.45536 25.25 10.1463 25.25H68.4878ZM32.9756 10.1C32.9756 12.7787 31.9066 15.3477 30.0038 17.2418C28.101 19.1359 25.5202 20.2 22.8293 20.2C20.1383 20.2 17.5575 19.1359 15.6547 17.2418C13.7519 15.3477 12.6829 12.7787 12.6829 10.1C12.6829 7.42131 13.7519 4.85234 15.6547 2.95822C17.5575 1.0641 20.1383 0 22.8293 0C25.5202 0 28.101 1.0641 30.0038 2.95822C31.9066 4.85234 32.9756 7.42131 32.9756 10.1Z",
    fill: "#004225"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/Step-3.263dfb65a00ce604d591d32631f70651.svg";
export { ForwardRef as ReactComponent };